<template>
  <!-- 个人中心页面 -->
  <section class="container">
    <Header></Header>
    <div class="wrapper">
      <div class="locationM text-left">
        <Breadcrumb>
          <img class="img" src="../assets/location.png" alt /> 当前位置：
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem>个人中心</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <div class="centerM">
        <Row>
          <Col span="14">
            <div class="title">个人中心</div>
            <div class="flex-row">
              <div class="col-30">
                <div class="avatar">
                  <img
                    v-if="$store.state.user.headImg != null "
                    :src="$store.state.user.headImg"
                    alt
                  />
                  <img
                    v-if="$store.state.user.headImg == null || $store.state.user.headImg =='' "
                    src="@/assets/head.png"
                    alt
                  />
                </div>
                <div>
                  <Button class="relative pointer" type="primary" style="width: 120px">
                    点击替换头像
                    <input
                      type="file"
                      class="pointer"
                      value
                      @change="setHeadImg"
                      accept="image/jpeg, image/png, image/jpg"
                    />
                  </Button>
                </div>
              </div>
              <div class="col-70">
                <div class="userM">
                  <el-form
                    :model="userForm"
                    status-icon
                    :rules="userFormRule"
                    ref="userForm"
                    label-width="100px"
                  >
                    <el-form-item label="姓名" prop="realName">
                      <el-input
                        type="text"
                        v-model="realName"
                        placeholder="请输入真实姓名"
                        autocomplete="off"
                        v-if="userForm.edit"
                        disabled
                      ></el-input>
                      <el-input
                        type="text"
                        v-model.trim="userForm.realName"
                        placeholder="请输入真实姓名"
                        v-if="!userForm.edit"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                      <el-input
                        type="text"
                        v-model="phone"
                        placeholder="请输入您的手机号"
                        autocomplete="off"
                        v-if="userForm.edit"
                        disabled
                      ></el-input>
                      <el-input
                        type="text"
                        v-model.trim="userForm.phone"
                        placeholder="请输入您的手机号"
                        autocomplete="off"
                        v-if="!userForm.edit"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="身份证" prop="idCard">
                      <el-input
                        type="text"
                        v-model="idCard"
                        placeholder="请输入您的身份证号"
                        autocomplete="off"
                        disabled
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="所在公司" prop="company">
                      <el-input
                        type="text"
                        v-model="company"
                        placeholder="请输入您的公司"
                        autocomplete="off"
                        disabled
                      ></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="editInfo" v-if="userForm.edit">编辑</el-button>
                      <el-button type="primary" @click="editInfo" v-else>取消</el-button>
                      <el-button type="primary" @click="saveInfo" :disabled="userForm.edit">保存</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <!-- <div class="userM"> -->
                <!--     <div class="flex-row">
                  <div class="col-30 text-right"> 姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名： </div>
                  <div class="col-50 text-left">
                    <span v-if="!setting">{{realName}}</span>
                    <Input v-else clearable v-model="realName" placeholder="请输入真实姓名" style="width: 270px;" />
                  </div>
                </div>
                <div class="flex-row">
                  <div class="col-30 text-right"> 手&nbsp;机&nbsp;号： </div>
                  <div class="col-50 text-left">
                    <span v-if="!setting">{{phone}}</span>
                    <Input v-else clearable v-model="phone" placeholder="请输入您的手机号" style="width: 270px;" />
                  </div>
                </div>
                <div class="flex-row">
                  <div class="col-30 text-right"> 身&nbsp;份&nbsp;证： </div>
                  <div class="col-50 text-left">
                    <span v-if="!setting">{{showUser(idCard)}}</span>
                    <Input v-else disabled v-model="idCard" placeholder="请输入您的公司" style="width: 270px;" />
                  </div>
                </div>
                <div class="flex-row">
                  <div class="col-30 text-right"> 所在公司： </div>
                  <div class="col-50 text-left">
                    <span v-if="!setting">{{company}}</span>
                    <Input v-else disabled v-model="company" placeholder="请输入您的公司" style="width: 270px;" />
                  </div>
                </div>
              </div>
              <div class="flex-row btnM">
                <div class="col-30 text-center">
                  <Button type="primary" style="width: 70px"  @click="setClick">编辑</Button>
                </div>
                <div class="col-50 text-left">
                  <Button type="primary" style="width: 70px" @click="set">保存</Button>
                </div>
                </div>-->
              </div>
            </div>
          </Col>
          <Col span="8" offset="2">
            <div class="title">修改密码</div>
            <div class="text-left">
              <div class="inputM">
                <el-form
                  :model="passwordForm"
                  status-icon
                  :rules="passwordRule"
                  ref="ruleForm"
                  label-width="100px"
                >
                  <el-form-item label="旧密码" prop="oldPassword">
                    <el-input
                      type="password"
                      v-model.trim="passwordForm.oldPassword"
                      placeholder="请输入旧密码"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="新密码" prop="newPassword">
                    <el-input
                      type="password"
                      v-model.trim="passwordForm.newPassword"
                      placeholder="请输入新密码"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="确认新密码" prop="checkNewPassword">
                    <el-input
                      type="password"
                      v-model.trim="passwordForm.checkNewPassword"
                      placeholder="请再次输入新密码"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="setPwd">确定</el-button>
                  </el-form-item>
                </el-form>
                <!-- <div>
                  <Input type="password" size="large" clearable v-model="password" placeholder="请输入旧密码" style="width: 300px;" />
                </div>
                <div>
                  <Input type="password" size="large" clearable v-model="rpassword" placeholder="请输入新密码" style="width: 300px" />
                </div>-->
              </div>
              <!-- <div>
              <Button type="primary" style="width: 100px" @click="setPwd">确定</Button>
              </div>-->
            </div>
          </Col>
        </Row>
      </div>
      <div class="certificationM">
        <div class="title">我的证书</div>
        <div class="inner-wrapper text-left" v-if="certificationList.length != 0">
          <div class="certification text-center" v-for="certification in certificationList">
            <img :src="certification" alt />
          </div>
        </div>
        <Alert class="alert" show-icon v-else>
          您目前尚未获得证书
          <template slot="desc">You have not yet obtained a certificate。</template>
        </Alert>
      </div>
      <div class="LogoutM text-left">
        <Button type="primary" style="width: 120px" @click="modal2 = true">退出登录</Button>
      </div>
    </div>
    <Modal v-model="modal2" width="360" :scrollable="scrollable">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>退出登录</span>
      </p>
      <div style="text-align:center">
        <p>确定要退出登录？</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="logout">确定</Button>
      </div>
    </Modal>
    <Footer></Footer>
  </section>
</template>
<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
import { MessageBox } from "element-ui";
export default {
  name: "Center",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.passwordForm.newPassword !== "") {
          this.$refs.ruleForm.validateField("chekNewPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        checkNewPassword: ""
      },
      passwordRule: {
        oldPassword: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur"
          }
        ],
        newPassword: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        checkNewPassword: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur"
          }
        ]
      },
      userForm: {
        realName: "",
        phone: "",
        idCard: "",
        company: "",
        edit: true
      },
      userFormRule: {
        realName: [
          {
            required: true,
            message: "姓名不可为空",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "手机号码不可为空",
            trigger: "blur"
          }
        ]
      },
      password: "",
      rpassword: "",
      certificationList: [],
      token: "",
      modal2: false,
      idCard: "",
      company: "",
      phone: "",
      realName: "",
      setting: false,
      scrollable: false
    };
  },
  created() {},
  mounted() {
    var user = JSON.parse(this.$cookie.get("xjaf-user"));
    console.log(user);
    this.realName = user.realName;
    this.userForm.realName = user.realName;
    this.phone = user.phone;
    this.userForm.phone = user.phone;
    this.company = user.company;
    this.idCard = user.idCard;
    this.getCertificate();
    this.setTab();
  },
  methods: {
    editInfo() {
      var that = this;
      that.userForm.edit = !that.userForm.edit;
      if (that.userForm.edit == false) {
        this.userForm.realName = this.realName;
        this.userForm.phone = this.phone;
      } else {
        this.$refs["userForm"].resetFields();
      }
    },
    saveInfo() {
      var that = this;
      var data = {
        company: that.userForm.company,
        phone: that.userForm.phone,
        realName: that.userForm.realName
      };
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          this.$http({
            url: that.webhost + "user/update",
            method: "POST",
            data: data
          }).then(({ data }) => {
            if (data && data.code === 0) {
              // that.$Message.success('修改信息成功!');
              that.getUser();
              MessageBox.alert("修改信息成功", "提示", {
                confirmButtonText: "确定",
                callback: action => {
                  that.$router.go(0);
                }
              });
            } else {
              that.$Message.error(data.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    setClick() {
      this.setting = !this.setting;
    },
    set() {
      var that = this;
      if (!that.setting) {
        return false;
      }
      if (!that.realName || !that.phone || !that.company) {
        this.$Message.warning("信息未填写完整!");
        return false;
      }
      that.setting = false;
      var data = {
        company: that.company,
        phone: that.phone,
        realName: that.realName
      };
      this.$http({
        url: that.webhost + "user/update",
        method: "POST",
        data: data
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.$Message.success("修改信息成功!");
          that.getUser();
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    logout() {
      this.$cookie.delete("xjaf-user");
      this.$cookie.delete("xjaf-token");
      this.$store.state.user = {};
      this.$store.state.isLogin = false;
      this.modal2 = false;
      this.$router.push("/");
      this.$Message.warning("已退出登录！");
    },
    setPwd() {
      var that = this;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          var data = {
            newPassword: that.passwordForm.newPassword,
            oldPassword: that.passwordForm.oldPassword
          };
          this.$http({
            url: that.webhost + "user/updatePassword",
            method: "POST",
            data: data
          }).then(({ data }) => {
            console.log(data);
            if (data && data.code === 0) {
              this.$Message.success("修改密码成功!");
              that.$refs["ruleForm"].resetFields();
            } else if (data.code === 500) {
              this.$Message.error("旧密码错误!");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getCertificate() {
      //获取用户证书
      var that = this;
      this.$http({
        url: that.webhost + "user/certificateList",
        method: "POST"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.certificationList = data.data;
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    getUser() {
      var that = this;
      //获取用户信息
      this.$http({
        url: that.webhost + "user/getUserInfo",
        method: "GET"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          console.log(data);
          this.$cookie.set("xjaf-user", JSON.stringify(data.data));
          this.$store.commit("getUser", data.data);
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    setHeadImg($event) {
      var that = this;
      let file = $event.target.files[0];
      let data = new FormData();
      data.append("file", file, file.name);
      this.$http({
        url: that.webhost + "user/uploadHeadImg",
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*/*"
        },
        data: data
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.$Message.success("修改头像成功!");
          that.getUser();
        } else {
          that.$Message.error(data.msg);
        }
      });
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>
<style scoped>
.wrapper {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 90px;
  font-family: "PingFang SC";
}

.title {
  text-align: left;
  font-size: 25px;
  line-height: 72px;
  color: #000;
  border-bottom: solid 2px #ccc;
}

.locationM {
  height: 30px;
  line-height: 30px;
  padding-top: 10px;
  /*padding-left: 28px;*/
}

.locationM .ivu-breadcrumb {
  font-size: 15px;
  color: #000;
  /*line-height: 0px;*/
}

.locationM img {
  width: 23px;
  height: 22px;
  margin-right: 5px;
  position: relative;
  top: 3px;
}

.centerM,
.certificationM {
  margin-top: 21px;
}

.certification {
  width: 50%;
  display: inline-block;
}

.certification img {
  width: 90%;
  height: 360px;
  border: solid 1px;
  border-color: #ccc;
  padding: 5px;
  margin-top: 20px;
  /*box-shadow: 0 0 10px 3px #f1f1f1;*/
}

.avatar,
.userM,
.inputM {
  padding: 20px 0;
}

.avatar img {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}

.userM {
  font-size: 16px;
  line-height: 36px;
}

.userM .col-50,
.btnM .col-50 {
  padding-left: 20px;
}

.inputM > div {
  height: 60px;
  line-height: 60px;
}

.relative input {
  width: 120px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.LogoutM {
  padding: 40px 10px 0;
}

.fs14 {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/Center.vue